export const QUOTEY_SLOGAN = "COMMERCIAL INSURANCE - SORTED";
export const COLORS = {
  primary_navyblue: "#3F445A",
  white_Indo: "#fff",

  toast_red: "#ea4252",

  secondary_orange: "#EA8F60",

  location_heading: "#C94C12",

  secondary_skyblue: "#49A8D6",

  tertiary_lightblue: "#9AC2EE",

  tertiary_ligthindigo: "#D6DAE7",

  tertiary_lightbackground: "#EFF3F7",

  rgba_primary_navyblue: "rgba(63,68,90,0.8)",

  question_background: "rgb(214, 218, 231)",

  // not mentioned in Templates but used ----------

  help_tip: "#F6F9FC",

  right_pane_background: "#D9DDEA",

  scrollbarbackground: "#AAAAAA",

  little_darker_lightindigo: "#C0C9E5",

  green_star: "#66E052",

  green_bar: "#1c7834",

  golden_star: "#cfb646",

  red_star: "#F8661D",

  red_dot: "#ff9980",

  green_dot: "#98e698",

  dark_green_dot: "#239023",

  purple_dot: "#d966ff",

  grey_font_header: "#928E8B",

  grey_font_cell: "#B0B2B3",

  warning_color: "#cfb646",

  navigation_header_tab: "#9BC3EC",

  navigation_in_between_line_color: "#383C50",

  qf_nav_plus_button_color: "#4EA9D4",

  question_area_bg: "#EFF3F6",

  back_button_color: "#888888",

  group_tab_header_completed: "#666666",

  group_tab_header_incomplete: "#B2B2B2",

  group_inbetween_border: "#C0C0C0",

  single_select_platinum_text: "#9E9FA0",

  platinum_option_main_font: "#6B6B6C",

  platinum_option_desc_font: "#A8AAAB",

  table_header_border: "#4DB3E2",

  table_header_color: "#48A9D6",

  dark_navy_blue: "#43414F",

  navigation_hovering: "#C0C9E5",

  anchor_blue: "#4CABD4",
};

let scales = {
  navheight: "6vmin",
  helpOrTipHeight: "12vmin",
  quotesLeftPaneWidth: "82%",
  heightAfterHelpOrTip: "",
  quotesRightPaneWidth: "",
  scrollbarThickness: "0.5vw",
  responsesSpacesBetweenScroll: "1vw",
  cloudIconSize: "17px",
  selectedNotSelectedIcon: "30px",
  actionPaddingLeft: "15%",
  actionPaddingRight: "12%",
  actionPaddingTop: "6vh",
  simpleQuestionsHeight: "10vh",
  navigationWidth: "20%",
  qfHelpOrTipWidth: "20%",
  qfNavTabHeaderHeight: "8.2vh",
  groupTabMinHeight: "7vh",
  groupTabBorderRadius: "1vmin",
  minHeightForGroupTab: "5vh",
  openedQuestionsLeftPadding: "3vw",
  openedQuestionsRightPadding: "4vw",
  openedQuestionMinHeight: "10vh",
  questionLeftPadding: "2vw",
  questionRightPadding: "2vw",
  minHeightForMultiSelectPlatinum: "25vh",
  minHeightForOptionsInSingleSelect: "5vmin",
  letfRighMarginInQuestionArea: "6vw",
  paddingTopInEachQuestionList: "2vh",
  pdfPaddingInsideFormGroupHeading: "15px",
  pdfWidth: 1122,
  pdfHeight: 1587,
  pdfTemplateA1HeaderHeight: 190,
  pdfTemplateA1FooterHeight: 112,
  pdfTemplateA1leftrightMargin: 10, // in percentage
  pdfRowQuestionBorderRadius: "7px",
  brokerageLogoHeight: "175px",
  brokerageLogoWidth: "227px",
  answerFontSize: "1.6vmin",
  commonBorderRadius: 5,
};

scales.heightAfterHelpOrTip = `calc(100% - ${scales.helpOrTipHeight})`;
scales.quotesRightPaneWidth = `calc(100% - ${scales.quotesLeftPaneWidth})`;

export const fwfh = {
  width: "100%",
  height: "100%",
};

export const inputStyle = {
  backgroundColor: COLORS.tertiary_ligthindigo,
  height: "5vh",
  width: "15vw",
  border: 0,
  borderRadius: 5,
  padding: "2vmin",
  letterSpacing: 1,
  color: COLORS.primary_navyblue,
  fontSize: "1.6vmin",
};
export const textAreaInputStyle = {
  backgroundColor: COLORS.tertiary_ligthindigo,
  height: "5vh",
  width: "15vw",
  border: 0,
  borderRadius: 5,
  padding: "0.2vmin",
  letterSpacing: 1,
  color: COLORS.primary_navyblue,
  fontSize: "1.6vmin",
};

export const SCALES = scales;
export const labelStyles = {
  fontFamily: "GibsonSemiBd",
  fontSize: "2.2vmin",
  marginBottom: "10px",
  color: COLORS.secondary_skyblue,
};
export const customMaterialUIClassForScrollBar = {
  responses: {
    "&::-webkit-scrollbar": {
      width: SCALES.scrollbarThickness,
      backgroundColor: "inherit",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: COLORS.little_darker_lightindigo,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: COLORS.primary_navyblue,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: COLORS.primary_navyblue,
    },
  },
};

export const customMaterialUIClassForScrollBarDarkBackgrond = {
  responses: {
    "&::-webkit-scrollbar": {
      width: SCALES.scrollbarThickness,
      backgroundColor: "inherit",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "white",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: COLORS.secondary_skyblue,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: COLORS.secondary_skyblue,
      cursor: "pointer",
    },
  },
};

export const columnWidthMyQuotesTable = {
  first: "10%",
  second: "15%",
  third: "10%",
  fourth: "10%",
  fifth: "10%",
  sixth: "",
  seventh: "10%",
  eighth: "10%",
  ninth: "10%",
};
export const columnWidthMyBinderTable = {
  first: "10%",
  second: "15%",
  third: "10%",
  // fourth: "10%",
  fifth: "10%",
  sixth: "",
  seventh: "10%",
  eighth: "10%",
  ninth: "10%",
};
export const columnWidthReminderTable = {
  first: "10%",
  second: "10%",
  third: "10%",
  fourth: "12%",
  fifth: "11%",
  sixth: "",
  seventh: "10%",
  eighth: "10%",
  ninth: " 10%",
};
export const columnWidthCertificateTable = {
  first: "14.29%",
  second: "14.29%",
  third: "14.29%",
  forth: "15%",
  fifth: "14.29%",
  sixth: "14.29%",
  seventh: "14.28%",
};
export const columnWidthMyQuotesBoard = {
  first: "11%",
  second: "12%",
  third: "11%",
  fourth: "11%",
  fifth: "11%",
  sixth: "11%",
  seventh: "11%",
  eighth: "11%",
  ninth: "11%",
};

export const pdfPageHeadingStyle = {
  width: "100%",
  minHeight: "75px",
  display: "flex",
  alignItems: "end",
  justifyContent: "start",
  fontFamily: "GibsonSemiBd",
  color: COLORS.secondary_orange,
  fontSize: "150%",
  letterSpacing: 1,
  paddingBottom: "10px",
  paddingLeft: SCALES.pdfPaddingInsideFormGroupHeading,
  paddingRight: SCALES.pdfPaddingInsideFormGroupHeading,
};

export const ResponsiveRegularFontSize = "min(15px, max(0.9vw,10px))";
